import vijaySingh_webp from '../assets/farmerImage/vijay_singh.webp';
import shri_kamlakar_gawali from '../assets/farmerImage/Shri_Kamlakar_Gawali.png';
import Shri_Bajirao_Kadam from '../assets/farmerImage/Shri_Bajirao_Kadam.png';
import avtar_singh from '../assets/farmerImage/avtar_singh.png';
import Shri_Vinod_Kumar_Siag from '../assets/farmerImage/Shri_Vinod_Kumar_Siag.png';
import bapu_dabade from '../assets/farmerImage/bapu_dabade.png';
import Mahipal_jadeja_2 from '../assets/farmerImage/Mahipal_jadeja_2.png';

export const FarmerTestimonials = [
  {
    text: 'My general practice included 11-12 irrigations in the season. This year I have done only 4 irrigations and saved a lot on fertilizers. I have saved around 50-60% on spraying costs. All this with 100% increase in fruitfulness. Thanks to Fyllo.',
    image: vijaySingh_webp,
    farmerName: 'Mr. Vijaysingh Kachare',
    location: 'Telangwadi, Mohol (Solapur)',
    crop: 'grapes',
  },
  {
    text: 'My Grape plants used to show various deficiencies due to  improper  irrigation  and  fertigation, but  with Fyllo’s suggestions, I overcome them and saved lot of cost. I gave fertilizers as per petiole report and saved excess fetilizers and their cost. Now I have excellent fruit quality and 60% increase in produce. ',
    image: shri_kamlakar_gawali,
    farmerName: 'Shri Kamlakar Gawali',
    location: 'Narayan tembhe, nashik',
    crop: 'grapes',
  },
  {
    text: 'I have saved 25% water and fertilizers by using Fyllo. Fyllo tells me the right time to spray, which has reduced my spraying cost by 20%. My total yield has also increased. Thank you Fyllo.',
    image: Shri_Bajirao_Kadam,
    farmerName: 'Shri Bajirao Kadam',
    location: 'Vita, Sangli',
    crop: 'grapes',
  },
  {
    text: "I have saved my Kinnow orchard from citrus psylla and also reduced my spraying cost with Fyllo's advance information on diseases and pests. kiFyllo device had already given information about gummosis, due to which I was able to stop gummosis.",
    image: avtar_singh,
    farmerName: 'Shri Avtaar Singh',
    location: 'Jhurar Khera , Punjab',
    crop: 'Kinnow',
  },
  {
    text: 'I have a Kinnow garden. There is little water scarcity in our area. Earlier my water used to get over in 3-4 days, but since I am giving water to Kinnow garden according to Fyllo, there is a lot of water saving since then. Due to proper management of fertilizers, the quality of fruits has improved, all are looking alike.',
    image: Shri_Vinod_Kumar_Siag,
    farmerName: 'Shri Vinod Kumar Siag',
    location: 'Fazilka , Punjab',
    crop: 'Kinnow',
  },
  {
    text: 'I have 5 acres of pomegranate orchard. For the last two years, I was getting less yield in this garden, because whenever I took the spray, it used to go out due to rain, the water was also getting less and more. But since Fyllo was planted, accurate watering has been done, due to understanding the weather forecast, the sprays have also been accurate. From which you can see that the same size, shining, color and weight of the fruit has also been given well. All this happened because of Fyllo. The garden which was failing since 4 years, I have made it successful this year.',
    image: bapu_dabade,
    farmerName: 'Shri Bapu Dabade',
    location: 'Sangola, Solapur',
    crop: 'pomegranate',
  },
  {
    text: 'Earlier, we used to give water on the basis of observation, it was not understood how much to give water, when to give it. But after installing the weather station, it was understood when to water the pomegranate, how much to water and for how many hours. Not only this, but how much fertilizer is to be given to the plant and how much fertilizer is needed, all this fertilizer schedule is available in the Fyllo app, due to which a lot of expenditure is saved in the cost of fertilizer.',
    image: Mahipal_jadeja_2,
    farmerName: 'Shri Mahipal Singh Jadeja',
    location: 'Sirohi, Gujarat',
    crop: 'pomegranate',
  },
];
